// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "4819fa60" + "-" + "85f5bcc5d7ba0336" + ".js";
};